import React from 'react';

import {useUnit} from 'effector-react';
import {Redirect, Route, RouteProps} from 'react-router-dom';

import {ROUTES} from '@app/routing';
import {userModel} from '@entities/user/model';
import {useUserPermissions} from '@entities/user/permissions';

export function PrivateRoute({children, ...rest}: RouteProps) {
    const {defaultPrivateRoute, hasPathAccess} = useUserPermissions();
    const user = useUnit(userModel);

    return (
        <Route
            {...rest}
            render={({location}) => {
                if (!user.state.isAuth || defaultPrivateRoute === ROUTES.LOGIN)
                    return <Redirect to={{pathname: ROUTES.LOGIN, state: {from: location}}} />;

                if (!hasPathAccess(rest.path))
                    return <Redirect to={{pathname: defaultPrivateRoute}} />;

                return children;
            }}
        />
    );
}
